import PropTypes from 'prop-types';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import I18n from 'i18n-js';
import _get from 'lodash/get';
import { Spin } from 'grab-ui';
import { deliverySelector } from 'selectors/new-booking-selectors';
import FatalErrorImage from 'public/images/fatal-error.svg';
import NoAvailableServiceImage from 'public/images/no-available-service.svg';
import ScribeDuck from 'ducks/scribe-duck';
import OverlayBody from '../overlay-body';
import ServiceTypesSection from './service-type-section';
import PickUpTimeSection from './pick-up-time-section';
import FatalError from '../fatal-error';

const ServiceConfigurationPanel = ({ dispatch, onClose, delivery }) => {
  const serviceTypes = _get(delivery, 'config.serviceTypes');
  const paxExpressError = _get(delivery, 'paxExpressError');
  const fetchingQuote = _get(delivery, 'fetchingQuote');

  const onConfirm = useCallback(
    () => {
      dispatch(ScribeDuck.creators.scribeExpressDeliveryConfirm());
      onClose();
    },
    [onClose],
  );

  const onBack = useCallback(
    () => {
      dispatch(ScribeDuck.creators.scribeExpressDeliveryOptionsBack());
      onClose();
    },
    [onClose],
  );

  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);
  const disabledConfirmService = !_get(
    delivery,
    'detail.configuration.serviceType',
    '',
  );

  if (!serviceTypes || serviceTypes.length === 0) {
    if (fetchingQuote) {
      return (
        <OverlayBody showConfirm={false}>
          <Spin style={{ margin: 'auto' }} />
        </OverlayBody>
      );
    }
    if (!paxExpressError) {
      return (
        <FatalError
          onClose={onClose}
          imgSrc={NoAvailableServiceImage}
          title={I18n.t('v2.error.home.noValidService.title')}
          description={null}
          confirmButtonText={I18n.t('v2.commonButton.ok')}
        />
      );
    }
    return (
      <FatalError
        onClose={refreshPage}
        imgSrc={FatalErrorImage}
        title={I18n.t('v2.error.home.fatalError.title')}
        description={I18n.t('v2.error.home.fatalError.description')}
        confirmButtonText={I18n.t('v2.error.home.fatalError.button')}
      />
    );
  }

  return (
    <OverlayBody
      showConfirm
      disabledConfirm={disabledConfirmService}
      onConfirmClick={onConfirm}
      showHeader
      showTitle
      title={I18n.t('v2.anytimeBooking.serviceConfigurationPanelTitle')}
      showClose
      onClose={onBack}
    >
      <ServiceTypesSection
        dispatch={dispatch}
        deliveryID={delivery.id}
        deliveryDetail={delivery.detail}
        config={delivery.config}
      />
      <PickUpTimeSection
        dispatch={dispatch}
        deliveryID={delivery.id}
        deliveryDetail={delivery.detail}
        fetchingQuote={fetchingQuote}
        config={delivery.config}
      />
    </OverlayBody>
  );
};

ServiceConfigurationPanel.propTypes = {
  delivery: NewBookingDeliveryPropType.isRequired,
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default connect((state, props) => ({
  delivery: deliverySelector(state, props),
}))(ServiceConfigurationPanel);
